import React from 'react';
import { LinearProgress, Typography, Stack } from '@mui/material';

type Props = {
  progress: number;
};

export const ProgressBar: React.FC<Props> = ({ progress }) => {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <LinearProgress variant="determinate" value={progress} />
      <Typography variant="body2">{progress}%</Typography>
    </Stack>
  );
};
